export const API = "https://house-manager-api.onrender.com/api/";
// export const API = "http://localhost:5000/api/";
